import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Layout from '../layout/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/product',
        component: () => import('@/views/product/index.vue')
      },
      {
        path: '/productDetail/:id',
        component: () => import('@/views/productDetail/index.vue')
      },
      {
        path: '/demo',
        component: () => import('@/views/demo/index.vue')
      },
      {
        path: '/demoDetail/:id',
        component: () => import('@/views/demoDetail/index.vue')
      },
      {
        path: '/solution',
        component: () => import('@/views/solution/index.vue')
      },
      {
        path: '/solutionDetail/:id',
        component: () => import('@/views/solutionDetail/index.vue')
      },
      {
        path: '/news',
        component: () => import('@/views/news/index.vue')
      },
      {
        path: '/newsDetail/:id',
        component: () => import('@/views/newsDetail/index.vue')
      },
      {
        path: '/resource',
        component: () => import('@/views/resource/index.vue')
      },
      {
        path: '/resourceDetail/:id',
        component: () => import('@/views/resourceDetail/index.vue')
      },
      {
        path: '/about',
        component: () => import('@/views/about/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savePosition) {
    // return 期望滚动到哪个的位置
    return {
      y: 0
    }
  }
})

export default router
